import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export function DetailSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="flex flex-col gap-2" data-slot="detail-section">
      <DetailHeading>{title}</DetailHeading>
      <DetailTable title={title}>{children}</DetailTable>
    </section>
  )
}

export function DetailHeading({ children }: { children: ReactNode }) {
  return <h2 className="text-foreground text-sm font-medium">{children}</h2>
}

export function DetailTable({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="border-border overflow-hidden rounded-md border">
      <table className="w-full border-collapse text-xs">
        <caption className="sr-only">{title}</caption>
        <tbody>{children}</tbody>
      </table>
    </div>
  )
}

export function DetailRow({
  label,
  value,
  mono = false,
  emptyValue = '—',
  labelClassName,
}: {
  label: string
  value: ReactNode
  mono?: boolean
  emptyValue?: ReactNode
  labelClassName?: string
}) {
  const present = value !== null && value !== undefined && value !== ''

  return (
    <tr className="border-border border-b last:border-b-0" data-slot="detail-row">
      <th
        scope="row"
        className={cn(
          'bg-muted/60 text-muted-foreground border-border w-28 whitespace-nowrap border-r px-3 py-1.5 text-left align-top font-medium sm:w-32',
          labelClassName,
        )}
      >
        {label}
      </th>
      <td
        className={cn(
          'text-foreground min-w-0 px-3 py-1.5 break-words',
          mono && present && 'font-mono text-[11px]',
          !present && 'text-muted-foreground',
        )}
      >
        {present ? value : emptyValue}
      </td>
    </tr>
  )
}
